import React from "react";

const Heading = ({ children, size, className }) => {
  switch (size) {
    case "h1":
      return (
        <h1
          className={`font-display font-semibold text-4xl tracking-[-3.5px] md:text-5xl lg:text-6xl ${
            className ? className : ""
          } mb-3`}
        >
          {children}
        </h1>
      );
    case "h2":
      return (
        <h2
          className={`font-display font-medium text-3xl tracking-[-1.5px] md:text-4xl lg:text-5xl ${
            className ? className : ""
          } mb-3`}
        >
          {children}
        </h2>
      );
    case "h3":
      return (
        <h3
          className={`font-display font-medium text-2xl tracking-[-1px] md:text-3xl lg:text-4xl ${
            className ? className : ""
          } mb-3`}
        >
          {children}
        </h3>
      );
    case "h4":
      return (
        <h4
          className={`font-display font-medium text-xl tracking-[-1px] md:text-2xl lg:text-3xl ${
            className ? className : ""
          } mb-3`}
        >
          {children}
        </h4>
      );
    case "h5":
      return (
        <h5
          className={`font-display font-medium md:text-xl text-xl tracking-[-0.5px] lg:text-2xl ${
            className ? className : ""
          } mb-3`}
        >
          {children}
        </h5>
      );
    case "h6":
      return (
        <h6
          className={`font-display font-medium text-lg tracking-[-0.5px] lg:text-xl ${
            className ? className : ""
          } mb-3`}
        >
          {children}
        </h6>
      );
    case "h7":
      return (
        <h7
          className={`font-display font-medium text-lg tracking-[-0.5px] !leading-5 lg:text-lg ${
            className ? className : ""
          } mb-3`}
        >
          {children}
        </h7>
      );
    default:
      return null;
  }
};

export default Heading;
